import React from 'react';

import KhoslaTestimonial from '@components/Images/Rebranding/KhoslaTestimonial';
import KhoslaTestimonialMobile from '@components/Images/Rebranding/KhoslaTestimonialMobile';
import SchmidtTestimonial from '@components/Images/Rebranding/SchmidtTestimonial';
import SchmidtTestimonialMobile from '@components/Images/Rebranding/SchmidtTestimonialMobile';

const Testimonials = () => {
  const khoslaTestimonial =
    '"The Information is one of the few trusted sources of tech news that I refernece on a daily basis." Vinod Khosla, Founder, Khosla Ventures';
  const schmidtTestimonial =
    '"The Information is an invaluable news source for the while industry." Eric Schmidt, Co-Founder of Schmidt Futures, Former CEO & Chairman of Google';
  return (
    <aside className="mt-48 border border-x-0 border-solid border-grayscale-beige py-32 sm:py-20">
      <div className="m-auto flex max-w-[480px] flex-col items-start justify-center gap-32 sm:gap-48 md:max-w-none md:flex-row">
        <KhoslaTestimonial
          aria-label={khoslaTestimonial}
          className="hidden w-full xs:block sm:h-[78px] sm:w-auto lg:h-[86px]"
        />
        <KhoslaTestimonialMobile
          aria-label={khoslaTestimonial}
          className="block max-h-[150px] xs:hidden"
        />
        <SchmidtTestimonial
          aria-label={schmidtTestimonial}
          className="hidden w-full xs:block sm:h-[110px] sm:w-auto lg:h-[118px]"
        />
        <SchmidtTestimonialMobile
          aria-label={schmidtTestimonial}
          className="block max-h-[173px] xs:hidden"
        />
      </div>
    </aside>
  );
};

export default Testimonials;
